import { createAction, handleActions } from 'redux-actions';

const setSorting = createAction("SCREENS/ORDERS/SET_SORTING");

const defaultState = {
  columnKey: 'date',
  order: 'descend'
};

const reducer = handleActions(
  {
    [setSorting]: (state, action) => Object.assign({}, state, action.payload)
  },
  defaultState
);

export { setSorting, reducer };